import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/site-logo1.png'
import _imports_1 from '../assets/images/vip.png'
import _imports_2 from '../assets/images/ticket-num.png'
import _imports_3 from '../assets/images/img32.png'
import _imports_4 from '../assets/images/img33.png'
import _imports_5 from '../assets/images/img34.png'
import _imports_6 from '../assets/images/img1.png'
import _imports_7 from '../assets/images/img6.png'
import _imports_8 from '../assets/images/trial.png'
import _imports_9 from '../assets/images/member.png'
import _imports_10 from '../assets/images/ticket.png'


const _withScopeId = n => (_pushScopeId("data-v-2b237ee8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "login"
}
const _hoisted_2 = { class: "login-title" }
const _hoisted_3 = { class: "login-time" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-arrow-clockwise",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "humberger__menu__logo" }, [
  /*#__PURE__*/_createElementVNode("a", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ])
], -1))
const _hoisted_6 = { class: "humberger__menu__cart" }
const _hoisted_7 = { class: "header__cart__price" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_9 = {
  class: "header__cart__price",
  style: {"margin-top":"10px"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_11 = { class: "humberger__menu__widget" }
const _hoisted_12 = { class: "header__top__right__language" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "arrow_carrot-down" }, null, -1))
const _hoisted_14 = { class: "header__top__right__auth" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-person-fill",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" })
], -1))
const _hoisted_16 = { class: "mobile-menu" }
const _hoisted_17 = { href: "#home" }
const _hoisted_18 = { href: "#download" }
const _hoisted_19 = { href: "#purchase" }
const _hoisted_20 = { href: "#contact" }
const _hoisted_21 = {
  key: 1,
  id: "preloder"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 2,
  class: "home"
}
const _hoisted_25 = { class: "header" }
const _hoisted_26 = { class: "header__top" }
const _hoisted_27 = { class: "container" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-lg-6 col-md-6" }
const _hoisted_30 = { class: "header__top__left" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-envelope-at",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2H2Zm3.708 6.208L1 11.105V5.383l4.708 2.825ZM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2-7-4.2Z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M14.247 14.269c1.01 0 1.587-.857 1.587-2.025v-.21C15.834 10.43 14.64 9 12.52 9h-.035C10.42 9 9 10.36 9 12.432v.214C9 14.82 10.438 16 12.358 16h.044c.594 0 1.018-.074 1.237-.175v-.73c-.245.11-.673.18-1.18.18h-.044c-1.334 0-2.571-.788-2.571-2.655v-.157c0-1.657 1.058-2.724 2.64-2.724h.04c1.535 0 2.484 1.05 2.484 2.326v.118c0 .975-.324 1.39-.639 1.39-.232 0-.41-.148-.41-.42v-2.19h-.906v.569h-.03c-.084-.298-.368-.63-.954-.63-.778 0-1.259.555-1.259 1.4v.528c0 .892.49 1.434 1.26 1.434.471 0 .896-.227 1.014-.643h.043c.118.42.617.648 1.12.648Zm-2.453-1.588v-.227c0-.546.227-.791.573-.791.297 0 .572.192.572.708v.367c0 .573-.253.744-.564.744-.354 0-.581-.215-.581-.8Z" })
], -1))
const _hoisted_32 = { class: "col-lg-6 col-md-6" }
const _hoisted_33 = { class: "header__top__right" }
const _hoisted_34 = { class: "header__top__right__language" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "arrow_carrot-down" }, null, -1))
const _hoisted_36 = { class: "header__top__right__auth" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-person-fill",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" })
], -1))
const _hoisted_38 = { class: "container" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header__logo" }, [
    /*#__PURE__*/_createElementVNode("a", { href: "" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      })
    ])
  ])
], -1))
const _hoisted_41 = { class: "col-xl-6 col-lg-9" }
const _hoisted_42 = { class: "header__menu" }
const _hoisted_43 = { href: "#home" }
const _hoisted_44 = { href: "#download" }
const _hoisted_45 = { href: "#purchase" }
const _hoisted_46 = { href: "#contact" }
const _hoisted_47 = { class: "col-lg-3" }
const _hoisted_48 = { class: "header__cart" }
const _hoisted_49 = { class: "header__cart__price" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_51 = { class: "header__cart__price" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overlay" }, null, -1))
const _hoisted_54 = {
  class: "hero hero-normal",
  id: "home"
}
const _hoisted_55 = { class: "container" }
const _hoisted_56 = { class: "row" }
const _hoisted_57 = { class: "col-lg-6" }
const _hoisted_58 = { class: "hero__text" }
const _hoisted_59 = { class: "offer-span" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "hero-span" }, "Ladder VPN")
], -1))
const _hoisted_61 = {
  class: "primary-btn",
  href: "#download"
}
const _hoisted_62 = {
  class: "purchase-btn",
  href: "#purchase"
}
const _hoisted_63 = { class: "col-lg-6" }
const _hoisted_64 = { class: "about-btn-list-home" }
const _hoisted_65 = ["href"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = ["href"]
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_70 = [
  _hoisted_69
]
const _hoisted_71 = ["href"]
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "Download"
}, null, -1))
const _hoisted_73 = [
  _hoisted_72
]
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("figure", {
  class: "banner-image",
  style: {"margin-top":"12px"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    alt: ""
  })
], -1))
const _hoisted_75 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  style: {"margin-top":"4px"},
  fill: "currentColor",
  class: "bi bi-list-stars",
  viewBox: "0 0 16 16"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5z"
}, null, -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M2.242 2.194a.27.27 0 0 1 .516 0l.162.53c.035.115.14.194.258.194h.551c.259 0 .37.333.164.493l-.468.363a.277.277 0 0 0-.094.3l.173.569c.078.256-.213.462-.423.3l-.417-.324a.267.267 0 0 0-.328 0l-.417.323c-.21.163-.5-.043-.423-.299l.173-.57a.277.277 0 0 0-.094-.299l-.468-.363c-.206-.16-.095-.493.164-.493h.55a.271.271 0 0 0 .259-.194l.162-.53zm0 4a.27.27 0 0 1 .516 0l.162.53c.035.115.14.194.258.194h.551c.259 0 .37.333.164.493l-.468.363a.277.277 0 0 0-.094.3l.173.569c.078.255-.213.462-.423.3l-.417-.324a.267.267 0 0 0-.328 0l-.417.323c-.21.163-.5-.043-.423-.299l.173-.57a.277.277 0 0 0-.094-.299l-.468-.363c-.206-.16-.095-.493.164-.493h.55a.271.271 0 0 0 .259-.194l.162-.53zm0 4a.27.27 0 0 1 .516 0l.162.53c.035.115.14.194.258.194h.551c.259 0 .37.333.164.493l-.468.363a.277.277 0 0 0-.094.3l.173.569c.078.255-.213.462-.423.3l-.417-.324a.267.267 0 0 0-.328 0l-.417.323c-.21.163-.5-.043-.423-.299l.173-.57a.277.277 0 0 0-.094-.299l-.468-.363c-.206-.16-.095-.493.164-.493h.55a.271.271 0 0 0 .259-.194l.162-.53z" }, null, -1))
const _hoisted_78 = [
  _hoisted_76,
  _hoisted_77
]
const _hoisted_79 = {
  class: "latest-product section-padding-100-0",
  id: "download"
}
const _hoisted_80 = { class: "container" }
const _hoisted_81 = { class: "row" }
const _hoisted_82 = {
  class: "col-lg-12",
  "data-v-df02a584": ""
}
const _hoisted_83 = {
  class: "section-title",
  "data-v-df02a584": ""
}
const _hoisted_84 = { "data-v-df02a584": "" }
const _hoisted_85 = { class: "callback-section primary-bg-callback" }
const _hoisted_86 = { class: "container" }
const _hoisted_87 = { class: "callback-inner" }
const _hoisted_88 = { class: "row align-items-center" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("figure", {
    id: "download",
    class: "callback-image"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_7,
      alt: ""
    })
  ])
], -1))
const _hoisted_90 = { class: "col-md-6" }
const _hoisted_91 = { class: "download" }
const _hoisted_92 = { class: "about-btn-list" }
const _hoisted_93 = ["href"]
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_95 = [
  _hoisted_94
]
const _hoisted_96 = ["href"]
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_98 = [
  _hoisted_97
]
const _hoisted_99 = ["href"]
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "Download"
}, null, -1))
const _hoisted_101 = [
  _hoisted_100
]
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overlay" }, null, -1))
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overlay" }, null, -1))
const _hoisted_104 = {
  class: "featured section-padding-85-0",
  id: "purchase"
}
const _hoisted_105 = { class: "container" }
const _hoisted_106 = { class: "row" }
const _hoisted_107 = { class: "col-lg-12" }
const _hoisted_108 = { class: "section-title" }
const _hoisted_109 = { class: "featured__controls" }
const _hoisted_110 = { class: "row featured__filter" }
const _hoisted_111 = { class: "featured__item" }
const _hoisted_112 = { class: "featured__item__title" }
const _hoisted_113 = { class: "item-img" }
const _hoisted_114 = {
  key: 0,
  src: _imports_8
}
const _hoisted_115 = {
  key: 1,
  src: _imports_9
}
const _hoisted_116 = {
  key: 2,
  src: _imports_10
}
const _hoisted_117 = { class: "item-details" }
const _hoisted_118 = { class: "item-pri" }
const _hoisted_119 = { key: 0 }
const _hoisted_120 = { class: "impressions" }
const _hoisted_121 = { class: "featured__item__text" }
const _hoisted_122 = { style: {"color":"crimson"} }
const _hoisted_123 = ["onClick"]
const _hoisted_124 = { class: "b-blue-btn load-more" }
const _hoisted_125 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overlay" }, null, -1))
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "overlay",
  style: {"top":"60%"}
}, null, -1))
const _hoisted_128 = {
  class: "footer spad",
  id: "contact"
}
const _hoisted_129 = { class: "container" }
const _hoisted_130 = { class: "row" }
const _hoisted_131 = { class: "col-lg-3 col-md-12" }
const _hoisted_132 = { class: "footer__about" }
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer__about__logo" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ])
], -1))
const _hoisted_134 = { class: "col-lg-3 col-md-12" }
const _hoisted_135 = { class: "footer__widget" }
const _hoisted_136 = { href: "#purchase" }
const _hoisted_137 = { href: "#contact" }
const _hoisted_138 = { class: "col-lg-3 col-md-12" }
const _hoisted_139 = { class: "footer__widget" }
const _hoisted_140 = { class: "textwidget widget-text" }
const _hoisted_141 = ["href"]
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-envelope-at",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2H2Zm3.708 6.208L1 11.105V5.383l4.708 2.825ZM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2-7-4.2Z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M14.247 14.269c1.01 0 1.587-.857 1.587-2.025v-.21C15.834 10.43 14.64 9 12.52 9h-.035C10.42 9 9 10.36 9 12.432v.214C9 14.82 10.438 16 12.358 16h.044c.594 0 1.018-.074 1.237-.175v-.73c-.245.11-.673.18-1.18.18h-.044c-1.334 0-2.571-.788-2.571-2.655v-.157c0-1.657 1.058-2.724 2.64-2.724h.04c1.535 0 2.484 1.05 2.484 2.326v.118c0 .975-.324 1.39-.639 1.39-.232 0-.41-.148-.41-.42v-2.19h-.906v.569h-.03c-.084-.298-.368-.63-.954-.63-.778 0-1.259.555-1.259 1.4v.528c0 .892.49 1.434 1.26 1.434.471 0 .896-.227 1.014-.643h.043c.118.42.617.648 1.12.648Zm-2.453-1.588v-.227c0-.546.227-.791.573-.791.297 0 .572.192.572.708v.367c0 .573-.253.744-.564.744-.354 0-.581-.215-.581-.8Z" })
], -1))
const _hoisted_143 = { class: "col-lg-3 col-md-12" }
const _hoisted_144 = { class: "footer__widget" }
const _hoisted_145 = ["href"]
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_147 = [
  _hoisted_146
]
const _hoisted_148 = ["href"]
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_150 = [
  _hoisted_149
]
const _hoisted_151 = ["href"]
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "Download"
}, null, -1))
const _hoisted_153 = [
  _hoisted_152
]
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row align-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "copy-right",
      style: {"text-align":"center"}
    }, "Copyright © 2023 ABS. Tech Inc. All Rights Reserved. ")
  ])
], -1))

import { onMounted } from "vue";
import QRCodeVue3 from "qrcode-vue3";
import { home } from "@/plugins/home"
import PayModal from "@/components/modal/PayModal.vue"
import DownloadModal from "@/components/modal/DownloadModal.vue"
// import { intercomService } from '@/plugins/intercomService';
// import { useEncryptedFieldsStorage } from "@/plugins/encryptedFieldsStorage";
// const listenerStore = useEncryptedFieldsStorage();
// listenerStore.initializeListeners();
// intercomService.load();

export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const {
  isLoading,
  isMenuVisible,
  isShowLoginView,
  ticketCount,
  vipTime,
  currentList,
  goodsIndex,
  selectIds,
  isAndroid,
  isIOS,
  isOther,
  qrLink,
  expirationTime,
  payRef,
  downloadRef,
  androidDownloadUrl,
  iosDownloadUrl,
  windowsDownloadUrl,
  email,
  handleWindowsDownload,
  getHwid,
  switchLocale,
  toggleMenu,
  cancelLogin,
  loginOrLogout,
  getLoginQrCode,
  getPackages,
  updateCurrentList,
  getUserInfo,
  checkClient,
  formatDayOrNum,
  formatDayVipName,
  checkAndLogin,
  isLogined,
  toBuyGoodsByButton,
  getResourceUrls,
  getLocalTips,
  setFacebookCookies,
} = home()

onMounted(async () => {

  checkClient()
  setFacebookCookies()
  // 硬件id用这个
  await getHwid()
  // 取token，发loginByToken
  await checkAndLogin()

  getPackages()
  getResourceUrls()
  // 检查是否登录成功
  if (isLogined()) {
    getUserInfo()

  }
  else {
    ticketCount.value = " 0"
    vipTime.value = ""
  }

});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isShowLoginView))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("message.scan_code")), 1),
          _createVNode(_unref(QRCodeVue3), {
            width: 250,
            height: 250,
            value: _unref(qrLink),
            myclass: "qrcode",
            image: "data:image/png;base64,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",
            qrOptions: { typeNumber: 0, mode: 'Byte', errorCorrectionLevel: 'Q' },
            imageOptions: { hideBackgroundDots: true, imageSize: 0.4, margin: 0 },
            dotsOptions: {
    type: 'square',
    color: '#007bff',
    gradient: null,
  },
            backgroundOptions: { color: '#ffffff' },
            cornersSquareOptions: { type: 'square', color: '#007bff' },
            cornersDotOptions: { type: undefined, color: '#007bff' },
            fileExt: "png",
            download: false
          }, null, 8, ["value"]),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("message.expiration_time")) + " " + _toDisplayString(_unref(expirationTime)), 1),
          _createElementVNode("button", {
            class: "login-refresh w-10 btn btn-lg btn-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(getLoginQrCode) && _unref(getLoginQrCode)(...args)))
          }, [
            _hoisted_4,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("message.refresh")), 1)
          ]),
          _createElementVNode("div", {
            class: "login-cancel",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(cancelLogin) && _unref(cancelLogin)(...args)))
          }, _toDisplayString(_ctx.$t("message.cancel_login")), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["humberger__menu__wrapper", { 'show__humberger__menu__wrapper': _unref(isMenuVisible) }])
    }, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createTextVNode(" " + _toDisplayString(_unref(vipTime) == "" ? _ctx.$t('message.be_member') : (_ctx.$t('message.vaild_date'))) + " " + _toDisplayString(_unref(vipTime)), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('message.ticket_count')) + _toDisplayString(_unref(ticketCount)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t("message.language")), 1),
          _hoisted_13,
          _createElementVNode("ul", null, [
            _createElementVNode("li", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(switchLocale)('zh-hk')))
            }, _toDisplayString(_ctx.$t('message.zh_hk')), 1),
            _createElementVNode("li", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(switchLocale)('en')))
            }, _toDisplayString(_ctx.$t('message.en')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("a", {
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(loginOrLogout) && _unref(loginOrLogout)(...args))),
            style: {"margin-left":"15px"}
          }, [
            _hoisted_15,
            _createTextVNode(" " + _toDisplayString(_unref(isLogined)() ? _ctx.$t('message.logout') : _ctx.$t('message.login')), 1)
          ])
        ])
      ]),
      _createElementVNode("nav", _hoisted_16, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("a", _hoisted_17, _toDisplayString(_ctx.$t('message.home')), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", _hoisted_18, _toDisplayString(_ctx.$t('message.download')), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", _hoisted_19, _toDisplayString(_ctx.$t('message.purchase')), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", _hoisted_20, _toDisplayString(_ctx.$t('message.contact')), 1)
          ])
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["humberger__menu__overlay", { active: _unref(isMenuVisible) }]),
      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(toggleMenu) && _unref(toggleMenu)(...args)))
    }, null, 2),
    (_unref(isLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
      : (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createElementVNode("header", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("ul", null, [
                        _createElementVNode("li", null, _toDisplayString(_ctx.$t('message.customer')), 1),
                        _createElementVNode("li", null, [
                          _hoisted_31,
                          _createTextVNode(" " + _toDisplayString(_unref(email).replace('@', "(at)")), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", null, _toDisplayString(_ctx.$t("message.language")), 1),
                        _hoisted_35,
                        _createElementVNode("ul", null, [
                          _createElementVNode("li", {
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(switchLocale)('zh-hk')))
                          }, _toDisplayString(_ctx.$t('message.zh_hk')), 1),
                          _createElementVNode("li", {
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(switchLocale)('en')))
                          }, _toDisplayString(_ctx.$t('message.en')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_unref(loginOrLogout) && _unref(loginOrLogout)(...args)))
                        }, [
                          _hoisted_37,
                          _createTextVNode(" " + _toDisplayString(_unref(isLogined)() ? _ctx.$t('message.logout') : _ctx.$t('message.login')), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("nav", _hoisted_42, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", _hoisted_43, _toDisplayString(_ctx.$t('message.home')), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", _hoisted_44, _toDisplayString(_ctx.$t('message.download')), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", _hoisted_45, _toDisplayString(_ctx.$t('message.purchase')), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", _hoisted_46, _toDisplayString(_ctx.$t('message.contact')), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _hoisted_50,
                      _createTextVNode(" " + _toDisplayString(_unref(vipTime) == "" ? _ctx.$t('message.be_member') : (_ctx.$t('message.vaild_date'))) + _toDisplayString(_unref(vipTime)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _hoisted_52,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('message.ticket_count')) + " " + _toDisplayString(_unref(ticketCount)), 1)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_53,
          _createElementVNode("section", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.$t('message.enjoy')), 1),
                    _hoisted_60,
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('message.enjoy_title')), 1),
                    _createElementVNode("a", _hoisted_61, _toDisplayString(_ctx.$t('message.download')), 1),
                    _createElementVNode("a", _hoisted_62, _toDisplayString(_ctx.$t('message.purchase')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    (_unref(isAndroid) || _unref(isOther))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: _unref(androidDownloadUrl),
                          style: {"margin-top":"12px"}
                        }, _hoisted_67, 8, _hoisted_65))
                      : _createCommentVNode("", true),
                    (_unref(isIOS) || _unref(isOther))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: _unref(iosDownloadUrl),
                          style: {"margin-top":"12px"}
                        }, _hoisted_70, 8, _hoisted_68))
                      : _createCommentVNode("", true),
                    _createElementVNode("a", {
                      href: _unref(windowsDownloadUrl),
                      style: {"margin-top":"12px","display":"inline-block","cursor":"pointer"},
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_unref(handleWindowsDownload) && _unref(handleWindowsDownload)(...args)))
                    }, _hoisted_73, 8, _hoisted_71)
                  ]),
                  _hoisted_74
                ])
              ]),
              _createElementVNode("div", {
                class: "humberger__open",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_unref(toggleMenu) && _unref(toggleMenu)(...args)))
              }, [
                (_openBlock(), _createElementBlock("svg", _hoisted_75, _hoisted_78))
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_79, [
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("div", _hoisted_82, [
                  _createElementVNode("div", _hoisted_83, [
                    _createElementVNode("h2", _hoisted_84, _toDisplayString(_ctx.$t("message.download")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("div", _hoisted_86, [
                    _createElementVNode("div", _hoisted_87, [
                      _createElementVNode("div", _hoisted_88, [
                        _hoisted_89,
                        _createElementVNode("div", _hoisted_90, [
                          _createElementVNode("div", _hoisted_91, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t("message.choose_platform")), 1),
                            _createElementVNode("h1", null, _toDisplayString(_ctx.$t("message.check_out")), 1),
                            _createElementVNode("h3", null, _toDisplayString(_ctx.$t("message.faster_safer")), 1),
                            _createElementVNode("div", _hoisted_92, [
                              (_unref(isAndroid) || _unref(isOther))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: _unref(androidDownloadUrl),
                                    style: {"margin-top":"12px"}
                                  }, _hoisted_95, 8, _hoisted_93))
                                : _createCommentVNode("", true),
                              (_unref(isIOS) || _unref(isOther))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    href: _unref(iosDownloadUrl),
                                    style: {"margin-top":"12px"}
                                  }, _hoisted_98, 8, _hoisted_96))
                                : _createCommentVNode("", true),
                              _createElementVNode("a", {
                                href: _unref(windowsDownloadUrl),
                                style: {"margin-top":"12px","display":"inline-block","cursor":"pointer"},
                                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_unref(handleWindowsDownload) && _unref(handleWindowsDownload)(...args)))
                              }, _hoisted_101, 8, _hoisted_99)
                            ])
                          ])
                        ])
                      ]),
                      _hoisted_102
                    ])
                  ])
                ])
              ]),
              _hoisted_103
            ])
          ]),
          _createElementVNode("section", _hoisted_104, [
            _createElementVNode("div", _hoisted_105, [
              _createElementVNode("div", _hoisted_106, [
                _createElementVNode("div", _hoisted_107, [
                  _createElementVNode("div", _hoisted_108, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.$t("message.purchase")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_109, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", {
                        class: _normalizeClass({ active: _unref(goodsIndex) == 0 }),
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_unref(updateCurrentList)('trial')))
                      }, _toDisplayString(_ctx.$t("message.trial")), 3),
                      _createElementVNode("li", {
                        class: _normalizeClass({ active: _unref(goodsIndex) == 1 }),
                        onClick: _cache[13] || (_cache[13] = ($event: any) => ( _unref(updateCurrentList)('member')))
                      }, _toDisplayString(_ctx.$t("message.member")), 3),
                      _createElementVNode("li", {
                        class: _normalizeClass({ active: _unref(goodsIndex) == 2 }),
                        onClick: _cache[14] || (_cache[14] = ($event: any) => ( _unref(updateCurrentList)('ticket')))
                      }, _toDisplayString(_ctx.$t("message.ticket")), 3)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_110, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentList), (goods) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["col-xl-3 col-lg-4 col-md-6 col-sm-12 mix", { selected: _unref(selectIds)[_unref(goodsIndex)] == goods.productId }]),
                    key: goods.productId
                  }, [
                    _createElementVNode("div", _hoisted_111, [
                      _createElementVNode("div", _hoisted_112, _toDisplayString(_unref(formatDayVipName)(goods.days)), 1),
                      _createElementVNode("div", _hoisted_113, [
                        (_unref(goodsIndex) == 0)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_114))
                          : (_unref(goodsIndex) == 1)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_115))
                            : (_openBlock(), _createElementBlock("img", _hoisted_116))
                      ]),
                      _createElementVNode("div", _hoisted_117, [
                        _createElementVNode("div", _hoisted_118, [
                          _createElementVNode("p", null, "U.S$" + _toDisplayString(goods.price), 1),
                          (goods.origPrice)
                            ? (_openBlock(), _createElementBlock("h5", _hoisted_119, [
                                _createTextVNode("U.S$"),
                                _createElementVNode("span", null, _toDisplayString(goods.origPrice), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_120, _toDisplayString(_unref(formatDayOrNum)(goods)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_121, [
                        _createElementVNode("h6", _hoisted_122, _toDisplayString(_unref(getLocalTips)(goods)), 1),
                        _createElementVNode("h6", null, _toDisplayString(_ctx.$t("message.unlimited_bandwidth")), 1),
                        _createElementVNode("h6", null, _toDisplayString(_ctx.$t("message.emali_support")), 1)
                      ]),
                      _createElementVNode("div", {
                        class: "col-sm-12 text-center",
                        onClick: ($event: any) => (_unref(toBuyGoodsByButton)(goods))
                      }, [
                        _createElementVNode("a", _hoisted_124, [
                          (goods.isLoading)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_125))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("message.purchase")), 1)
                        ])
                      ], 8, _hoisted_123)
                    ])
                  ], 2))
                }), 128))
              ]),
              _hoisted_126
            ])
          ]),
          _createVNode(PayModal, {
            ref_key: "payRef",
            ref: payRef
          }, null, 512),
          _hoisted_127,
          _createElementVNode("footer", _hoisted_128, [
            _createElementVNode("div", _hoisted_129, [
              _createElementVNode("div", _hoisted_130, [
                _createElementVNode("div", _hoisted_131, [
                  _createElementVNode("div", _hoisted_132, [
                    _hoisted_133,
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t("message.product_desc")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_134, [
                  _createElementVNode("div", _hoisted_135, [
                    _createElementVNode("h6", null, _toDisplayString(_ctx.$t("message.quick_links")), 1),
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", _hoisted_136, _toDisplayString(_ctx.$t("message.purchase")), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", _hoisted_137, _toDisplayString(_ctx.$t("message.contact")), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_138, [
                  _createElementVNode("div", _hoisted_139, [
                    _createElementVNode("h6", null, _toDisplayString(_ctx.$t("message.contact_info")), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("message.customer_support")), 1),
                    _createElementVNode("div", _hoisted_140, [
                      _createElementVNode("a", {
                        href: 'mailto:' + _unref(email)
                      }, [
                        _hoisted_142,
                        _createTextVNode(" " + _toDisplayString(_unref(email).replace('@', "(at)")), 1)
                      ], 8, _hoisted_141)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_143, [
                  _createElementVNode("div", _hoisted_144, [
                    _createElementVNode("h6", null, _toDisplayString(_ctx.$t("message.download")), 1),
                    _createElementVNode("a", { href: _unref(androidDownloadUrl) }, _hoisted_147, 8, _hoisted_145),
                    _createElementVNode("a", { href: _unref(iosDownloadUrl) }, _hoisted_150, 8, _hoisted_148),
                    _createElementVNode("a", {
                      href: _unref(windowsDownloadUrl),
                      style: {"display":"inline-block","cursor":"pointer"},
                      onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_unref(handleWindowsDownload) && _unref(handleWindowsDownload)(...args)))
                    }, _hoisted_153, 8, _hoisted_151),
                    _createVNode(DownloadModal, {
                      ref_key: "downloadRef",
                      ref: downloadRef
                    }, null, 512)
                  ])
                ])
              ]),
              _hoisted_154
            ])
          ])
        ]))
  ], 64))
}
}

})